const dbRequest = require('../../../../../js-network/db-request')
const dtHandler = require('../../../../../components/dt/dt-handler')

const columns = [
  { key: 'current', label: 'Customer', behavior: false, displayText: true },
  { key: 'total_due_30_days', label: '30 days', behavior: false, displayText: true },
  { key: 'total_due_31_to_60_days', label: '31 to 60 days', behavior: false, displayText: true },
  { key: 'total_due_61_to_90_days', label: '61 to 90 days', behavior: false, displayText: true },
  { key: 'total_due_over_90_days', label: 'Over 90 days', behavior: false, displayText: true },
  { key: 'total_balance', label: 'Total', behavior: false, displayText: true },
]

const emptyAging = {
  current: '$0.00',
  total_due_30_days: '$0.00',
  total_due_31_to_60_days: '$0.00',
  total_due_61_to_90_days: '$0.00',
  total_due_over_90_days: '$0.00',
  total_balance: '$0.00',
}

let requestVersion = 0

export async function load(customerId, htmlFc) {
  const container = getContainer(htmlFc)
  const currentRequest = ++requestVersion

  clearContainer(container)

  if (!customerId) { return }

  const result = await dbRequest.start(
    { inf: { customer_id: customerId } },
    'server/php/queries/entityFunction/sale-customer-aging.php'
  )

  // Ignore an older response if the user selected another customer meanwhile.
  if (currentRequest !== requestVersion) { return }
  if (!result || result.status !== 'ok' || !Array.isArray(result.data)) { return }

  const data = result.data.length > 0 ? result.data : [emptyAging]
  const customerName = result.data[0]?.customer || getSelectedCustomerName(htmlFc) || 'Customer'
  const customerColumns = columns.map((column, index) => (
    index === 0 ? { ...column, label: customerName } : column
  ))

  container.innerHTML = dtHandler.dtSimpleFc(data, customerColumns)
  container.classList.remove('dn')
}

export function clean(htmlFc) {
  requestVersion++
  clearContainer(getContainer(htmlFc))
}

function getContainer(htmlFc) {
  return htmlFc.fullcontHTML.querySelector('#sale-customer-aging')
}

function getSelectedCustomerName(htmlFc) {
  const label = htmlFc.fullcontHTML.querySelector('#sale_form_customer_id .chip-cont .chip label')
  if (!label) { return '' }

  return label.textContent.split(' - Credit Limit:')[0].trim()
}

function clearContainer(container) {
  container.innerHTML = ''
  container.classList.add('dn')
}
